import ApiService from "@Src/services/ApiService";
import {INSTITUTE_PAYMENT_API_ROUTES } from "./InstitutePayment.api.constant";


export async function institutePaymentCheck(payload: any) {
    return await ApiService.fetchData({
        url: INSTITUTE_PAYMENT_API_ROUTES.INSTITUTE_PAYMENT_CHECK,
        method: 'POST',
        data: payload
    });
}


export async function createInstitutePaymentOrder(payload: any) {
    return await ApiService.fetchData({
        url: INSTITUTE_PAYMENT_API_ROUTES.CREATE_INSTITUTE_PAYMENT_ORDER,
        method: 'POST',
        data: payload
    });
}

export async function subscribeInstitutePlan(payload: any) {
    return await ApiService.fetchData({
        url: INSTITUTE_PAYMENT_API_ROUTES.SUBSCRIBE_INSTITUTE_PLAN,
        method: 'POST',
        data: payload
    });
}

export async function instituteTopupCheck(payload: any) {
    return await ApiService.fetchData({
        url: INSTITUTE_PAYMENT_API_ROUTES.INSTITUTE_TOPUP_CHECK,
        method: 'POST',
        data: payload
    });
}
export async function instituteSubscriptionTopup(payload: any) {
    return await ApiService.fetchData({
        url: INSTITUTE_PAYMENT_API_ROUTES.INSTITUTE_SUBSCRIPTION_TOPUP,
        method: 'POST',
        data: payload
    });
}
